const commentList = () =>
  import(/* webpackChunkName: "newFm~commentList" */ 'page/newFm/commentList')

let routes = [
  {
    path: '/newFm/commentList',
    component: commentList,
    meta: {
      cache: false
    }
  }
]
export default routes
